export default __webpack_public_path__ + "static/media/86.c4870de0.png";